/* Copied from
 * https://github.com/jonschlinkert/detect-case/blob/v1.0.0/index.js
 */

export const detectCase = (token: string): string => {
    if (token.includes("_") && /^([A-Z][A-Z0-9_]+)+$/.test(token))
        return "uppersnake";
    if (token.includes("_") && /^([a-z][a-z0-9_]+)+$/.test(token))
        return "snakecase";
    if (token.includes("-") && /^([a-z][-a-z0-9]+)+$/.test(token))
        return "kebabcase";
    if (/^[a-z0-9_]+$/.test(token)) return "lowercase";
    if (/^[A-Z][A-Z0-9_]*$/.test(token)) return "uppercase";
    if (/^([A-Z][a-z0-9_]*[A-Z]*){2,}$/.test(token)) return "pascalcase";
    if (/^([a-z][a-z0-9_]*[A-Z][a-z0-9_]*)+$/.test(token)) return "camelcase";
    if (/^[A-Z][a-z]*$/.test(token)) return "titlecase";
    if (/^[A-Z][a-z0-9_]*$/.test(token)) return "mixedcase";
    return "unknown";
};
